import cache from "./cache";

export default [
  cache
]



// WEBPACK FOOTER //
// ./src/store/cache/index.js